import { DeliveriesListParams } from './../../_proxy/params/deliverieslist.param';
import { ImageBoxDialogComponent } from '@m4u-angular/ui/dialogs/imagebox-dialog/imageboxdialog.component';
import { FileListDialogComponent } from '@dato-dialogs/file-list-dialog/file-list-dialog.component';
import { ScreenService } from '@m4u-angular/core/framework/screen.service';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, BaseEntity } from '@m4u-angular/base/entities/BaseEntities';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { Component, ViewChild } from '@angular/core';
import { BalanceView } from '@dato-proxy/views/balance.view';
import { BaseDocument } from '@dato-proxy/entities/basedocument.entity';
import { PrintBoxDialogComponent } from '@m4u-angular/ui/dialogs/printbox-dialog/printboxdialog.component';
import { EnumCRUDActions } from '@m4u-angular/core/framework/sysenums.enum';
import { DataSourceCustomAction } from '@m4u-angular/base/datalayer/BaseDataSources';
import { TransDocumentListParams } from '@dato-proxy/params/transdocumentlist.param';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { LedgerEndpoint } from '@dato-proxy/endpoints/ledger.endpoint';
import { InvoiceEndpoint } from '@dato-proxy/endpoints/invoice.endpoint';
import { AgingTransDocumentEndpoint } from '@dato-proxy/endpoints/agingtransdocument.endpoint';
import { DeliveryEndpoint } from '@dato-proxy/endpoints/delivery.endpoint';
import { CustomerEndpoint } from '@dato-proxy/endpoints/customer.endpoint';
import { PdfEndpoint } from '@dato-proxy/endpoints/pdf.endpoint';
import { PaymentRequest } from '@dato-proxy/entities/paymentrequest.entity';
import { Globals } from '../../_globals';
import { BaseGridDocumentComponent } from '../base/base-grid-document-component';
import { ToolbarSettings, ContextMenuElement } from '@m4u-angular/base/classes/BaseClasses';
import { FileEndpoint } from '@dato-proxy/endpoints/file.endpoint';
import { File as FileEntity } from '@dato-proxy/entities/file.entity';
import { EnumFileTypes, EnumReportTabs, EnumSystemTypes, EnumDocumentFilteringOption } from '@dato-proxy/enums';
import { Utils } from '@m4u-angular/core/helpers/Utils';
import { CompanyEndpoint } from '@dato-proxy/endpoints/company.endpoint';
import { CompanyView } from '@dato-proxy/views/company.view';
import { formatDate } from 'devextreme/localization';
import { DocumentsDownloadParams } from '../../_proxy/params/documentsdownload.param';
import { EnumPdfDocumentViewType } from '@dato-pages/pdf-page/pdf-page.component';
import { PaymentDialogComponent } from '@dato-dialogs/payment-dialog/payment-dialog.component';
import { EnumDocumentDownloadOption } from '../../_proxy/enums';

export class ReportsState extends BaseState {
    FromDate: Date;
    UntilDate: Date;
    IsOpen = true;
    BalanceView: BalanceView;
    ReportTabs: any[];

    Document: BaseDocument;
    Documents: BaseDocument[];
    TotalSum: number;
    IsSingleCurrency: boolean;
    PaymentCurrency: string;

    CurrentTabIndex = 0;
    IsShowBalance: boolean;
    IsShowBalanceLate: boolean;
    IsAllowLedger: boolean;
    IsHideShowOpenOnly: boolean;
    IsShowAttachments: boolean;
    IsAllowPayment: boolean;

    IsActiveUser: boolean;

    CurrentFileName: string;
    CurrentFileData: any;

    IsEnableMultiCompany: boolean;
    IsSingleCompany: boolean;
    Companies: CompanyView[];
    CompanyID: number;
    PaymentCompanyID: number;
    IsInitDone: boolean=false;
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss']
})
export class ReportsComponent extends BasePageComponent<BaseEntity, ReportsState> {

    @ViewChild('printBoxDialog') printBoxDialog: PrintBoxDialogComponent;
    @ViewChild(FileListDialogComponent) fileListDialog: FileListDialogComponent;
    @ViewChild(ImageBoxDialogComponent) imageDialog: ImageBoxDialogComponent;
    @ViewChild(PaymentDialogComponent) paymentDialog: PaymentDialogComponent;
    @ViewChild('grid') grid: BaseGridDocumentComponent<BaseEntity>;
    public get G() { return (this.grid as any)?.G; }
    public downloadOptions = ['PDF', 'ZIP'];

    constructor(A: ServiceBagService,
        private ledgerEndpoint: LedgerEndpoint,
        private invoiceEndpoint: InvoiceEndpoint,
        private agingTransDocumentEndpoint: AgingTransDocumentEndpoint,
        private deliveryEndpoint: DeliveryEndpoint,
        private customerEndpoint: CustomerEndpoint,
        private fileEndpoint: FileEndpoint,
        private companyEndpoint: CompanyEndpoint) {
        super(A, 'ReportsComponent', BaseEntity, ReportsState);
    }

    override OnInitComponent() {
        if ((this.A.Screen.IsMobile() && this.A.Navigator.GetCurrentRouteWithoutParams().endsWith('reports'))
            || (this.A.Screen.IsDesktop() && this.A.Navigator.GetCurrentRouteWithoutParams().endsWith('accounting'))) {
            this.Framework.NavigateDefault();
            return;
        }

        this.State.IsShowBalance = Globals.SystemOption.IsShowBalance;
        this.State.IsShowBalanceLate = Globals.SystemOption.IsShowBalanceLate;
        this.State.IsAllowLedger = Globals.SystemOption.IsAllowLedger;
        this.State.IsActiveUser = Globals.IsActiveUser;
        this.State.IsHideShowOpenOnly = Globals.SystemOption.IsShowOpenOnly;
        this.State.IsShowAttachments = Globals.SystemOption.IsShowAttachments;
        this.State.IsAllowPayment = Globals.SystemOption.IsAllowPayment;

        // if default date is set then add filter
        if (Globals.SystemOption.DefaultMonthToShow >= 1 && Globals.SystemOption.DefaultMonthToShow < 50) {
            var date = new Date();
            const newDate = new Date(date.valueOf());
            newDate.setMonth(date.getMonth() - Globals.SystemOption.DefaultMonthToShow);
            this.State.FromDate = newDate;
        }

        this.InitCompanies();
        this.InitTabs();

        // if filter option is automatic then first check if customer has open documents and only then refresh the data
        if (Globals.SystemOption.DocumentFilteringOption == EnumDocumentFilteringOption.Automatic) {
            this.Do(this.customerEndpoint.HasOpenDocuments(), false, (response) => {
                this.State.IsOpen = response.Data;
                this.LoadDataSource();
                this.State.IsInitDone = true;
            });
        }
        else {
            if (Globals.SystemOption.DocumentFilteringOption == EnumDocumentFilteringOption.ShowAll) this.State.IsOpen = false;
            this.LoadDataSource();
            this.State.IsInitDone = true;
        }
        this.InitTotalBalance();
        
    }

    override OnGetToolbarSettings() {
        const settings = {
            IsAllowExport: true,
            IsAllowPrint: true,
            GridExtender: this.G
        } as ToolbarSettings;
        return settings;
    }

    override OnExternalEntitySaved(ExternalEntity: BaseEntity, ExternalEntityType: new () => BaseEntity, ExternalEntityAction: EnumCRUDActions) {
        if (ExternalEntityType === PaymentRequest) {
            this.LoadDataSource();
            this.InitTotalBalance();
        }
    }

    override OnGetFilterDescription(): string {
        if (this.State.FromDate || this.State.UntilDate) { return `${this.RC('lblReportPeriod')}: ${this.State.FromDate ? formatDate(this.State.FromDate, this.F.DateFormatShort) : ''}-${this.State.UntilDate ? formatDate(this.State.UntilDate, this.F.DateFormatShort) : ''}`; }

        return '';
    }

    protected override OnGetPrintTitle(): string {
        return this.CurrentTabName;
    }

    OnFilterChanged() {
        this.LoadDataSource();
    }

    OnShowPdf(document: BaseDocument) {
        this.Navigate(['/pages/pdf_view', document.DocumentNumber], { ViewType: EnumPdfDocumentViewType.Inner, DocumentType: document.TransType, ShowAsWindow: true });
        return;
    }

    OnPayBySelected() {
        Globals.PaymentDocuments = this.State.Documents;
        this.paymentDialog.ShowDialogShort(() => {}, () => {});
    }

    OnPayByOne(document: BaseDocument) {
        Globals.PaymentDocuments = [document];
        this.paymentDialog.ShowDialogShort(() => {}, () => {});
    }

    OnSelectionChanged(Documents: BaseDocument[]) {
        this.State.Documents = Documents.filter(x => x.PaymentSum && x.PaymentSum !== 0 && x['IsPaymentAllowed'] !== false);
        this.State.TotalSum = this.State.Documents.reduce((sum, current) => sum + current.PaymentSum, 0);

        if (this.HasRepeatedValue(this.State.Documents, 'PaymentCurrency')) {
            this.State.IsSingleCurrency = false;
            this.A.UI.StopMessage(this.State.CurrentTabIndex === 3 ? this.RC('msgDeliveriesDifferentCurrencies') : this.RC('msgDocumentDifferentCurrencies'));
            return;
        }

        this.State.PaymentCurrency = this.State.Documents.length > 0 ? this.State.Documents[0].PaymentCurrency : null;
        this.State.IsSingleCurrency = true;

        if (this.State.IsEnableMultiCompany) {
            if (this.HasRepeatedValue(this.State.Documents, 'CompanyID')) {
                this.State.IsSingleCompany = false;
                this.A.UI.StopMessage(this.State.CurrentTabIndex === 3 ? this.RC('msgDeliveriesDifferentCompanies') : this.RC('msgDocumentDifferentCompanies'));
                return;
            }

            this.State.PaymentCompanyID = this.State.Documents.length > 0 ? this.State.Documents[0].CompanyID : null;
            this.State.IsSingleCompany = true;
        }
    }

    OnTabChanged() {
        this.InitDocuments();
        this.LoadDataSource();

        setTimeout(() => { this.ReloadToolbar(); });
    }

    Abs(value: number) {
        return Math.abs(value);
    }

    OnShowFiles(document: BaseDocument) {
        this.Do(this.fileEndpoint.GetList(document.TransType, document.SBODocumentEntry), false, (response) => {
            if (response.Entities.length === 1) {
                this.OnShowFile(response.Entities[0]);
            } else {
                this.fileListDialog.Show(response.Entities);
            }
        });
    }

    OnShowFile(file: FileEntity) {
        this.State.CurrentFileName = `${file.Name}${file.Extension}`;

        this.Do(this.fileEndpoint.GetFileData(file.EntryID), false, (response: any) => {
            this.State.CurrentFileData = response;

            // Show the pdf
            if (file.FileType === EnumFileTypes.Pdf) {
                this.ShowFilePdf();
                // Show the image
            } else if (file.FileType === EnumFileTypes.Image) {
                this.ShowFileImage();
                // Download the file
            } else { this.OnDownloadFile(); }
        });
    }

    OnDownloadFile() {
        // Create a tag 'a' and click it
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(this.State.CurrentFileData);
        a.download = this.State.CurrentFileName;
        a.click();
    }


    OnDownloadAllFiles(e) {
        let bIsZIP: boolean = e.itemData == 'ZIP';
        const params = new DocumentsDownloadParams();
        params.DateFrom = this.State.FromDate;
        params.DateUntil = this.State.UntilDate;
        params.IsOpen = this.State.IsOpen;
        params.DownloadOption = bIsZIP ? EnumDocumentDownloadOption.ZIP : EnumDocumentDownloadOption.PDF;
        if (this.State.IsEnableMultiCompany && this.State.CompanyID) { params.CompanyID = this.State.CompanyID; }
        //params.ReportTab = this.State.CurrentTabIndex
        switch (this.State.CurrentTabIndex) {
            case 0:
                params.ReportTab = EnumReportTabs.Ledger;
                break;
            case 1:
                params.ReportTab = EnumReportTabs.Invoice;
                break;
            case 2:
                params.ReportTab = EnumReportTabs.AgingReport;
                break;
            case 3:
                params.ReportTab = EnumReportTabs.Delivery;
                break;
            default:
                return;
        }
        this.Do(this.fileEndpoint.GetAllDocumentsPdfData(params), true, (response: any) => {
            if (response.IsSuccess) {
                if (response.Data != undefined && response.Data != "") {
                    let oBlob = Utils.ConvertToBlob(response.Data, "octet/stream");
                    let oLink = document.createElement('a');
                    oLink.href = window.URL.createObjectURL(oBlob);
                 
                    oLink.download = bIsZIP? "documents.zip": "documents.pdf";
                    oLink.click();
                }
            }
        });
    }

    OnChangeCompany() {
        if (!this.State.IsInitDone) return;
        if (this.State.CompanyID == undefined) this.State.CompanyID = -1;
        this.InitTotalBalance();
        this.LoadDataSource();
    }

    get CurrentTabName(): string { return this.State.ReportTabs.filter(x => x.index === this.State.CurrentTabIndex)[0].text; }

    private ShowFileImage() {
        // Filling the image dialog
        this.imageDialog.Title = this.State.CurrentFileName;
        this.imageDialog.ImageSource = this.State.CurrentFileData;
        // Show the image dialog
        this.imageDialog.ShowDialogShort(() => { });
        
    }

    protected ShowFilePdf() {
        // Set the filename and the title
        this.printBoxDialog.FileName = this.State.CurrentFileName;
        this.printBoxDialog.Title = this.State.CurrentFileName;
        // Set the pdf data
        this.printBoxDialog.PDFData = this.State.CurrentFileData;
        // Show the dialog
        this.printBoxDialog.ShowDialogShort(undefined);
    }

    protected InitTabs() {
        switch (Globals.SystemOption.SystemType) {
            case EnumSystemTypes.Landlord: {
                this.State.ReportTabs = this.LIST('ReportTabsLandLord');
                break;
            }
            case EnumSystemTypes.Zulu: {
                this.State.ReportTabs = this.LIST('ReportTabsZulu');
                break;
            }
            default: {
                this.State.ReportTabs = this.LIST('ReportTabs');
                break;
            }
        }


        // filter ledger
        this.State.ReportTabs[0].visible = Globals.SystemOption.IsAllowLedger;
        // filter invoice
        this.State.ReportTabs[1].visible = Globals.SystemOption.IsAllowInvoices;
        // filter aging report
        this.State.ReportTabs[2].visible = Globals.SystemOption.IsAllowAgingReport;
        // filter deliveries
        this.State.ReportTabs[3].visible = Globals.SystemOption.IsAllowDeliveries;

        // set current tab
        const visibleTabs = this.State.ReportTabs.filter(x => x.visible);

        if (this.QueryParams.Tab) {
            const tab = visibleTabs.find(x => x.index === parseInt(this.QueryParams.Tab, 10));
            if (tab != null) { this.State.CurrentTabIndex = tab.index; }
        }

        if (!this.State.CurrentTabIndex) {
            this.State.CurrentTabIndex = visibleTabs.length > 0 ? visibleTabs[0].index : -1;
        }
    }

    private InitTotalBalance() {
        this.Do(this.customerEndpoint.GetBalance(this.State.CompanyID), false, (response) => { this.State.BalanceView = response.Entity; });
    }

    protected InitDocuments() {
        this.State.Documents = [];
        this.State.TotalSum = 0;
    }

    private LoadDataSource() {
        const params = new TransDocumentListParams();
        params.RefDateFrom = this.State.FromDate;
        params.RefDateUntil = this.State.UntilDate;
        params.IsOpen = this.State.IsOpen;
        if (this.State.IsEnableMultiCompany && this.State.CompanyID) { params.CompanyID = this.State.CompanyID; }

        this.InitDocuments();
        if (this.grid) { this.grid.ClearSelection(); }
        this.DataSources['Ledgers'] = new DataSourceCustomAction((options: DataLoadOptions) => {
            params.HasComplexFilter = options['ComplexFilter'] ? true : false;
            return this.ledgerEndpoint.GetListByParams(params, options);
        }, undefined, undefined, true, { paginate: false });

        this.DataSources['Invoices'] = new DataSourceCustomAction((options: DataLoadOptions) => 
            this.invoiceEndpoint.GetListByParams(params, options), undefined, undefined, true, { paginate: false });

        // Show open only for Aging report always
        const agingReportParams = Utils.CloneObject(params) as TransDocumentListParams;
        agingReportParams.IsOpen = true;
        this.DataSources['AgingReport'] = new DataSourceCustomAction((options: DataLoadOptions) => 
            this.agingTransDocumentEndpoint.GetListByParams(agingReportParams, options), undefined, undefined, false, { paginate: false });

        // Define a data source for the deliveries grid
        const deliveriesParams = new DeliveriesListParams();
        deliveriesParams.DeliveryDateFrom = this.State.FromDate;
        deliveriesParams.DeliveryDateUntil = this.State.UntilDate;
        deliveriesParams.IsOpen = this.State.IsOpen;
        if (this.State.IsEnableMultiCompany && this.State.CompanyID) { deliveriesParams.CompanyID = this.State.CompanyID; }

        this.DataSources['Deliveries'] = new DataSourceCustomAction((options: DataLoadOptions) => 
            this.deliveryEndpoint.GetListByParams(deliveriesParams, options), undefined, undefined, true, { paginate: false });

    }

    private InitCompanies() {
        this.State.IsEnableMultiCompany = Globals.SystemOption.IsEnableMultiCompany;

        if (this.State.IsEnableMultiCompany) {
            this.Do(this.companyEndpoint.List(), false, (response) => {
                this.State.Companies = response.Entities || [];
                if (this.State.Companies.length === 1) {
                    this.State.CompanyID = this.State.Companies[0].EntryID;
                    return;
                }
                if (this.State.Companies.length > 1) {
                    const allCompaniesItem = this.GetAllCompaniesItem();
                    this.State.Companies.unshift(allCompaniesItem);
                    this.State.CompanyID = allCompaniesItem.EntryID;
                    return;
                }
                this.State.CompanyID = undefined;
            });
        }
    }

    private GetAllCompaniesItem() {
        const allCompaniesItem = new CompanyView();
        allCompaniesItem.EntryID = -1;
        allCompaniesItem.Code = '-1';
        allCompaniesItem.Name = this.RC("lblAllCompanies");

        return allCompaniesItem;
    }

    private HasRepeatedValue(arr: any[], fieldName: string) {
        if (!arr || arr.length === 0) { return false; }

        const oldValue = arr[0][fieldName];

        for (let i = 1; i < arr.length; i++) {
            if (oldValue !== arr[i][fieldName]) { return true; }
        }

        return false;
    }

    OnClearFilter() {
        this.State.CompanyID = this.State.FromDate = this.State.UntilDate = undefined;
        this.State.IsOpen = true;
    }
}
